import { useEffect, useState } from "react";
import { X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

import {
  updateParams,
  updateVideoPageState,
} from "../../../Pages/Video/VideoActions";
import { submitDeleteVideo } from "../../SharedActions";
import "../FlaggedModal/FlaggedModal.scss";

const VideoConfirmDelete = () => {
  const [loading, setLoading] = useState(false);
  const [videoPayload, setVideoPayload] = useState([]);

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const confirmDelete = useSelector(
    (state) => state.videoPageStates.confirmDelete
  );
  const successfullyDeleted = useSelector(
    (state) => state.videoPageStates.successfullyDeleted
  );
  const deleteVideosCheckList = useSelector(
    (state) => state.videoPageStates.deleteVideosCheckList
  );
  const tab = useSelector((state) => state.videoParams.tab);
  const videos = useSelector((state) => state.videos);

  useEffect(() => {
    setVideoPayload(
      deleteVideosCheckList.map((i) => ({
        video_id: i,
        manufacturer_ids:
          videos.find((j) => j?.video?._id === i)?.video?.manufacturer_ids ||
          [],
      }))
    );
  }, [deleteVideosCheckList]);

  const sumbitDelete = () => {
    submitDeleteVideo(deleteVideosCheckList, tab === "Competition")
    // submitDeleteVideo(deleteVideosCheckList)
      .then((response) => {
        if (response) {
          setLoading(false);
          dispatch(updateVideoPageState({ successfullyDeleted: true }));
          dispatch(updateParams({ reFetch: true }));
          if (pathname !== "/videos") navigate("/videos");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Modal
      size="sm"
      style={{ maxWidth: "510px" }}
      isOpen={confirmDelete}
      className="ConfirmUnflag modal-dialog-centered"
    >
      <ModalHeader className="justify-content-end">
        <X
          size={30}
          role="button"
          className="closeBtn"
          onClick={() => {
            successfullyDeleted
              ? dispatch(
                  updateVideoPageState({
                    successfullyDeleted: false,
                    confirmDelete: false,
                    deleteVideosCheckList: [],
                    deleteChecks: false,
                    deleteSelectAll: false,
                  })
                )
              : dispatch(updateVideoPageState({ confirmDelete: false }));
          }}
        />
      </ModalHeader>
      <ModalBody className="p-0">
        {!successfullyDeleted ? (
          <>
            <div className="d-flex justify-content-center">
              <div className="mb-2">
                <h2 style={{ lineHeight: "44px", color: "black" }}>
                  Are you sure you want to delete{" "}
                  {deleteVideosCheckList.length === 1 ? "this" : "these"} video
                  {deleteVideosCheckList.length > 1 ? "s" : null} permanently?
                </h2>
              </div>
            </div>
            <div className="d-flex justify-content-between ">
              <Button
                className="video-process-btn"
                size="lg"
                color="outline-primary"
                onClick={() => {
                  dispatch(updateVideoPageState({ confirmDelete: false }));
                }}
              >
                No
              </Button>
              <Button
                className="video-process-btn"
                size="lg"
                color="primary"
                onClick={sumbitDelete}
                disabled={loading}
              >
                Yes
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="d-flex justify-content-center">
              <div className="mb-2">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={
                      require(`@src/assets/images/vyrill/trash-icon.png`)
                        .default
                    }
                    width={40}
                    alt=""
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <h2
                    style={{
                      marginTop:"42px",
                      lineHeight: "44px",
                      color: "black",
                      width: "64%",
                      textAlign: "center",
                    }}
                  >
                    {deleteVideosCheckList.length === 1
                      ? "This video has"
                      : `${deleteVideosCheckList.length} videos have`}{" "}
                    been deleted permanently
                  </h2>
                </div>
              </div>
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default VideoConfirmDelete;
